export enum InventoryDisplay {
  CALL_FOR_AVAILABILITY,
  SHOW_ZERO,
  AVAILABLE_AT_LOCATION,
}
